<form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">

    <nav class="toolbar navbar navbar-light">
        <div class="form-inline">
            <button [disabled]="!habilitarNuevoProducto" type="button" title="Nuevo Producto" class="btn btn-outline-success" (click)="onAdd()"><i class="fa fa-file-o"></i> Nuevo Producto</button>
            <button *ngIf="!visibilitySpinner" [disabled]="!habilitarGuardar" title="Guardar Solicitud" class="btn btn-outline-success" type="button" (click)="guardarSolicitud()"><i class="fa fa-save"></i> Guardar Solicitud</button>
            <button *ngIf="visibilitySpinner" [disabled]="true" class="btn btn-outline-success">
                <p-progressSpinner class="spinnerExcel"></p-progressSpinner>
                Guardando
            </button>
        </div>
    </nav>

    <div class="animated fadeIn container-fluid">
        <h4 style="display:inline">Productos {{refAtestFito}}</h4>
        <h5 style="display:inline; margin-left: 8px">
            <span>
                <img class="estado-icono-big" container="body" src="{{IdTipoSolicitudAtestFito | IconoTipoSolicitudAtest}}" ngbTooltip="{{tituloTipoSolicitud}}" />
                <img class="estado-icono-big" container="body" src="{{IdEstadoSolicitudAtestFito | IconoEstadoSolicitudAtest}}" ngbTooltip="{{tituloEstadoSolicitud}}" />
            </span>
        </h5>

        <div class="row">
            <div class="col-md-12">

                <div class="row" style="margin-bottom: 10px;">

                    <div class="form-group col-md-3">
                        <label class="col-form-label" for="">Sin Productos</label>
                        <p-toggleButton class="form-control-togglebutton" formControlName="SinProductos" onLabel="Sí" offLabel="NO" onIcon="pi pi-check" (onChange)="onSelectedSinProductos()"
                                        offIcon="pi pi-times"></p-toggleButton>
                    </div>

                    <div class="form-group col-md-3">
                        <label class="col-form-label" [ngClass]="{ 'required-field' : campoObligatorio }" for="">Unidad de Medida</label>
                        <ng-select [items]="listTipoCantidad"
                                   bindLabel="Descripcion"
                                   bindValue="Id"
                                   formControlName="IdTipoCantidadAtestFito"
                                   loadingText="Cargando..."
                                   [readonly]="!listTipoCantidad || listTipoCantidad.length === 0"
                                   [loading]="!listTipoCantidad || listTipoCantidad.length === 0"
                                   notFoundText="Unidad de Medida no encontrada"
                                   placeholder="-- Seleccione una Unidad de Medida --"
                                   [ngClass]="displayFieldCssNgSelect('IdTipoCantidadAtestFito')"
                                   (change)="onSelectTipoCantidad()"
                                   clearAllText="Eliminar selección">
                        </ng-select>

                        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('IdTipoCantidadAtestFito','required')">
                            Unidad de Medida es obligatoria
                        </div>
                    </div>
                </div>

                <div *ngIf="campoObligatorio" class="row">
                    <div class="form-group col-md-12">
                        <label class="col-form-label" for="">* NOTA: Antes de añadir productos a la solicitud, asegúrese de guardar la Unidad de Medida</label>
                    </div>
                </div>

                <div class="row">
                    <!--GRID PRODUCTOS-->
                    <div class="col-md-12">
                        <div class="card card-accent-success animated fadeIn">
                            <div class="card-header-buscador">
                                <i class="fa fa-align-justify"></i> <strong>Lista de productos</strong>
                            </div>
                            <div class="card-body-grid">
                                <p-table #tableSearch autoLayout="true" [value]="productosAtestFitoCollection"
                                         [columns]="colsProds" sortField="Id" sortOrder="-1"
                                         styleClass="table table-responsive-sm table-striped table-sm table-0-marginbot"
                                         [ngClass]="displayGridHidden(productosAtestFitoCollection)">

                                    <ng-template pTemplate="header" let-columns>
                                        <tr>
                                            <th scope="col" *ngFor="let col of columns" [ngStyle]="{'display': col.display}" [pSortableColumn]="col.field">
                                                {{col.header}}
                                                <p-sortIcon *ngIf="col.field!=='Link'" [field]="col.field"></p-sortIcon>
                                            </th>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="body" let-rowData let-columns="columns" let-expanded="expanded" let-rowIndex="rowIndex">
                                        <tr>
                                            <td *ngFor="let col of columns" [ngStyle]="{'display': col.display}">
                                                <span *ngIf="(col.field!=='Link' && col.field!=='Grupo' && col.field!=='IdFormaDescripcion' && col.field!=='Peso' && col.field!=='Volumen')">
                                                    {{rowData[col.field]}}
                                                </span>
                                                <span *ngIf="(col.field==='Grupo' || col.field==='IdFormaDescripcion')" ngbTooltip="{{ rowData[col.field] }}">
                                                    {{rowData[col.field] | truncate:[25, '...'] }}
                                                </span>
                                                <span *ngIf="(col.field==='Peso' || col.field==='Volumen')">
                                                    {{rowData[col.field] | number:'1.3-3':'es'}}
                                                </span>
                                                <div *ngIf="col.field==='Link'" class="btn-group">
                                                    <div *ngIf="productoEditable">
                                                        <button (click)="onEdit(rowData)" type="button" title="Editar"
                                                                class="btn btn-sm btn-warning">
                                                            <span class="fa fa-edit"></span>
                                                        </button>
                                                    </div>
                                                    <div *ngIf="!productoEditable">
                                                        <button (click)="onEdit(rowData)" type="button" title="Consultar"
                                                                class="btn btn-sm btn-info">
                                                            <span class="fa fa-search"></span>
                                                        </button>
                                                    </div>

                                                    <div *ngIf="productoBorrable">
                                                        <button (click)="onDelete(rowData)" type="button" title="Eliminar"
                                                                class="btn btn-sm btn-danger">
                                                            <span class="fa fa-remove"></span>
                                                        </button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                                <div *ngIf="numeroProductos === 0" class="empty-grid">
                                    No hay productos asociados a la solicitud
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>
